class TreeMapWidget extends BaseWidget<TreeMapResultVM, TreeMapConfig> {
    override widgetType = WidgetType.TreeMap;

    constructor(container: any, tab: WorkbookTab, $reportContent, dashboardWidget: DashboardWidget) {
        super(container, tab, $reportContent, dashboardWidget);
    }

    setConfig(config) {
        this.itemConfig = new TreeMapConfig(config);
    }

    setResult(result) {
        this.result = new TreeMapResultVM(result);

        let self = this;
        let dataSource = this.getDataSource();
        let metricName = ko.computed(function () {
            return replaceBasicHtmlContent(MappingService.getMetricName(self.itemConfig.metric()));
        });
        this.result.treeMapSettings = {
            width: "100%",
            height: "100%",
            dataSource: dataSource,
            labelField: 'labelField',
            idField: 'xArgument',
            layoutAlgorithm: this.itemConfig.layout() as any,
            parentField: this.itemConfig.groupField() !== null ? 'xGroupArgument' : undefined,
            valueField: this.result?.metric?.queryName ?? "",
            colorizer: this.getColorizer() as any,
            tooltip: {
                enabled: true,
                zIndex: 200,
                customizeTooltip(arg) {
                    let argumentText = arg.node.data.xArgument || arg.node.data.xGroupArgument;
                    let valueText = self.formatValue(arg.value);
                    let text = `${(argumentText === null ? irSettings.nullText : argumentText === undefined ? "" : argumentText)}<br/>${metricName()}: ${valueText}`;

                    return {
                        html: text,
                    };
                },
            },
            onInitialized: function(this: TreeMapWidget, e) {
                this.result.treeMapComponent = e.component;
            }.bind(this),
            onClick: function (e) {
                if (!self.tabOrWidget.drilldownManager.isDrilldownPossible() || workbook.workbookConfig.isPrinting)
                    return;

                let data = {
                    name: "",
                    startCondition: null,
                    isGroupField: false
                };
                let tabValues: Array<FilterValuesVM> = [data];

                if (e.node?.data) {
                    if (e.node.data.items) { //Group click
                        data.name = result.groupField.queryName;
                        data.startCondition = e.node.data.items[0][result.groupField.queryName];
                        data.isGroupField = true;
                    }
                    else {
                        if (result.groupField) {
                            data.name = result.groupField.queryName;
                            data.startCondition = e.node.data[result.groupField.queryName];
                            data.isGroupField = true;
                        }

                        if (e.node.data.items === undefined) {
                            tabValues.push({
                                name: result.field.queryName,
                                startCondition: e.node.data[result.field.queryName],
                                isGroupField: false
                            });
                        }
                    }
                }
                
                self.executeDrilldown(tabValues);
            }
        };
    }

    setupSettings() {
        let self = this;
        let updateDataSource = (newValue: boolean, widget: TreeMapWidget, isActiveDrilldown: boolean) => {
            let dataSource = self.getDataSource();
            widget.result.treeMapComponent.option("dataSource", dataSource);
        }
        this.createSettingItem(this.itemConfig.label.format, "label.format", UpdateSettingMode.Custom, updateDataSource);
        this.createSettingItem(this.itemConfig.label.showMetric, "label.showMetric", UpdateSettingMode.Custom, updateDataSource);
        this.createSettingItem(this.itemConfig.label.decimalPlaces, "label.decimalPlaces", UpdateSettingMode.Custom, updateDataSource);
        this.createSettingItem(this.itemConfig.label.unitFormat, "label.unitFormat", UpdateSettingMode.Custom, updateDataSource);

        let updateColorizer = (newValue: boolean, widget: TreeMapWidget, isActiveDrilldown: boolean) => {
            widget.result.treeMapComponent.option("colorizer", undefined);
            widget.result.treeMapComponent.option("colorizer", self.getColorizer() as any);
        };
        this.createSettingItem(this.itemConfig.colorization, "colorization", UpdateSettingMode.Custom, updateColorizer);
        this.createSettingItem(this.itemConfig.formattingRule, "formattingRule", UpdateSettingMode.Custom, updateColorizer);
        this.createSettingItem(this.itemConfig.startColor, "startColor", UpdateSettingMode.Custom, updateColorizer);
        this.createSettingItem(this.itemConfig.endColor, "endColor", UpdateSettingMode.Custom, updateColorizer);
        this.createSettingItem(this.itemConfig.colorizeGroups, "colorizeGroups", UpdateSettingMode.Custom, updateColorizer);

        this.createSettingItem(this.itemConfig.layout, "layout", UpdateSettingMode.Custom, (newValue: boolean, widget: TreeMapWidget, isActiveDrilldown: boolean) => {
            widget.result.treeMapComponent.option("layoutAlgorithm", self.itemConfig.layout() as any);
            updateColorizer(newValue, widget, isActiveDrilldown);
        });

        //let update = (newValue: boolean, widget: TreeMapWidget, isActiveDrilldown: boolean) => {
        //    //widget.tabOrWidget.drilldownManager.refresh();
        //}

        //this.createSettingItem(this.itemConfig.metric, "metric", UpdateSettingMode.Custom, update);
        //this.createSettingItem(this.itemConfig.field, "field", UpdateSettingMode.Custom, update);
        //this.createSettingItem(this.itemConfig.groupField, "groupField", UpdateSettingMode.Custom, update);

        this.createSettingItem(this.itemConfig.topBottomType, "topBottomType", UpdateSettingMode.Reload);
        this.createSettingItem(this.itemConfig.topBottomValue, "topBottomValue", UpdateSettingMode.Reload);
    }

    repaint() {

    }

    runSetup() {

    }

    setup() {
    }

    private getDataSource(): DevExpress.data.DataSource<unknown, unknown> {
        if (!this.result || !this.result.dataTable) {
            return new DevExpress.data.DataSource({
                store: [],
                paginate: false,
            });
        }

        const hasGroup = this.itemConfig.groupField() !== null;
        let newResult = [];

        var createObj = function (this: TreeMapWidget, propertName: string, obj, value, field: TreeMapColumnInfo) {
            if (obj[propertName] === undefined) {
                obj[propertName] = "";
            }
            else {
                obj[propertName] += `${irSettings.columnSeparator}`;
            }

            if (field.autoGrouping !== AutoGroupingEnum.None) {
                let output = getAutoGroupingText(value, field.autoGrouping);
                obj[propertName] += `${output}`;
            }
            else {
                obj[propertName] += `${value === null ? irSettings.nullText : value !== undefined ? value : ""}`;
            }
        }.bind(this);

        for (const data of this.result.dataTable) {
            let obj = {} as any;

            let value = data[this.result.field.index];
            obj[this.result.field.queryName] = value;
            createObj("xArgument", obj, value, this.result.field);

            obj.labelField = obj.xArgument;
            if (this.itemConfig.label.showMetric()) {
                obj.labelField = `${obj.xArgument} - ${this.formatValue(data[this.result.metric.index], true)}`;
            }

            if (hasGroup) {
                let value = data[this.result.groupField.index];
                obj[this.result.groupField.queryName] = value;
                createObj("xGroupArgument", obj, value, this.result.groupField);
            }

            obj[this.result.metric.queryName] = data[this.result.metric.index];
            if (this.itemConfig.maxValue === undefined || obj[this.result.metric.queryName] > this.itemConfig.maxValue) {
                this.itemConfig.maxValue = obj[this.result.metric.queryName];
            }

            newResult.push(obj);
        }

        if (hasGroup) {
            //Add the groups as new rows in the array to behavior like parents
            let parentsForTreeMap = [...new Set(newResult.map((item) => item.xGroupArgument))];
            for (const parent of parentsForTreeMap) {
                newResult.push({
                    xGroupArgument: '',
                    xArgument: parent,
                    labelField: parent
                });
            }
        }

        return new DevExpress.data.DataSource({
            store: newResult,
            paginate: false,
        });
    }

    private getColorizer() {
        let formattingRuleObj = FormattingRuleService.getFormattingRuleById(this.itemConfig.formattingRule());
        let range = undefined;
        if (this.itemConfig.colorization() === TreeMapColorizationEnum.Range && formattingRuleObj) {
            range = formattingRuleObj.scales.map((x) => x.minValue);
            range.push(this.itemConfig.maxValue);
        }
        return {
            type: this.itemConfig.colorization(),
            colorizeGroups: this.itemConfig.colorization() === TreeMapColorizationEnum.Discrete ? this.itemConfig.colorizeGroups() : false,
            palette: this.itemConfig.colorization() === TreeMapColorizationEnum.Gradient ? [this.itemConfig.startColor(), this.itemConfig.endColor()] : this.itemConfig.colorization() === TreeMapColorizationEnum.Range && formattingRuleObj ? formattingRuleObj.scales.map((x) => x.color || x.backgroundColor) : undefined,
            range: range
        };
    }

    private formatValue(value: number, isLabel: boolean = false) {
        let dx = DevExpress as any;
        let largerNumber = "Normal";
        if (isLabel) {
            largerNumber = labelFormatEnumToString(this.itemConfig.label.unitFormat());
        }

        const currencySign = this.result.metric.accountingStyle ? "accounting" : "standard";
        const decimalPlaces = this.itemConfig.label.decimalPlaces() === -1 || !isLabel ? this.result.metric.decimalPlaces : this.itemConfig.label.decimalPlaces();
        const format = this.itemConfig.label.format() === FieldFormatEnum.None || !isLabel ? this.result.metric.metricFormat : this.itemConfig.label.format();

        if (format === FieldFormatEnum.Currency)
            return `${dx.formatHelper.format(value, { style: "currency", currency: this.result.currencyCode, currencyDisplay: "narrowSymbol", precision: decimalPlaces, currencySign: currencySign, largerNumber: largerNumber })}`;
        else if (format === FieldFormatEnum.Percentage)
            return `${dx.formatHelper.format(value, { style: "percent", precision: decimalPlaces, currencySign: currencySign })}`;

        return `${dx.formatHelper.format(value, { style: "decimal", precision: decimalPlaces, largerNumber: largerNumber, currencySign: currencySign })}`;
    }
}